<template>
    <div id="data-list-list-view" class="data-list-container" @click="closeSelects">
        <vs-table
            ref="table"
            no-data-text="Nenhuma lista de favoritos encontrada"
            pagination
            :max-items="itemsPerPage"
            :data="usersList"
        >
            <div slot="header" class="flex w-full items-end">
                <div>
                    <vs-input
                        placeholder="Buscar"
                        class="w-full input-rounded-full no-icon-border mr-4"
                        icon="icon-search"
                        icon-pack="feather"
                        v-model="term"
                        @keyup.enter="searchHandler()"
                    />
                </div>
                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-end">
                    <div class="flex flex-wrap-reverse items-start">
                        <vs-select
                                class="mr-4"
                                placeholder="Selecione os usuários"
                                multiple
                                label="Usuários"
                                v-model="selectedUsers"
                                ref="usersSelect"
                                >

                                <vs-select-item
                                    :key="index"
                                    :value="item.id"
                                    :text="item.name"
                                    v-for="(item, index) in usersOptions"
                                />
                        </vs-select>

                        <vs-button 
                            class="mr-4" 
                            color="success" 
                            type="filled" 
                            @click="shareList" 
                            >
                            Compartilhar
                        </vs-button>
                    </div>
                </div>
            </div>

            <template slot="thead">
                <vs-th sort-key="name">Nome</vs-th>
                <vs-th sort-key="email">E-mail</vs-th>
            </template>

            <template slot-scope="{ data }">
                <tbody>
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                            <p class="term font-medium">{{ tr.name }}</p>
                        </vs-td>
                        <vs-td>
                            <p class="term font-medium">{{ tr.email }}</p>
                        </vs-td>
                        <vs-td>
                            <span @click="confirmDeleteShare(tr.id)">
                                <vx-tooltip text="Apagar" class="w-6 h-6" color="danger">
                                    <feather-icon icon="XCircleIcon" class="w-6 h-6"></feather-icon>
                                </vx-tooltip>
                            </span>
                        </vs-td>
                    </vs-tr>
                </tbody>
            </template>
        </vs-table>
    </div>
</template>

<script>
import { sync, call } from "vuex-pathify";
export default{
     data() {
        return {
            itemsPerPage: 40,
            isMounted: false,
            term:"",
            selectedUsers:[]
        };
    },
    async mounted(){
        this.fetchUsersOptions();
    },
    computed: {
        ...sync([
            "favoriteList/id",
            "favoriteList/selectedItems",
            "usersFavoriteLists/usersList",
            "usersFavoriteLists/usersOptions"
        ])
    },
    async created(){
        // this.reset();
        this.$vs.loading();
        
        try {
            await this.fetch(this.$route.params.id);
            this.$vs.loading.close();
        } catch (error) {
            this.$vs.loading.close();
            this.$vs.notify({
                title: "Erro",
                text:"Não foi possível carregar esta página. Tente novamente mais tarde, por favor.",
                color: "danger",
                iconPack: "feather",
                icon: "icon-alert-circle"
            });
        }
    },

    methods: {
        ...call([
            "usersFavoriteLists/fetch",
            "usersFavoriteLists/fetchUsersOptions",
            "usersFavoriteLists/shareFavoriteList",
            "usersFavoriteLists/removeUserFavoriteList",
            "usersFavoriteLists/reset"
        ]),
        closeSelects() {
            this.$refs.usersSelect.closeOptions();
        },
        async shareList(){
            this.$vs.loading();
            try {
                await this.shareFavoriteList({"favorite_list_id":this.$route.params.id,"users_id": this.selectedUsers});
                await this.reset();
                this.$vs.loading.close();
                this.selectedUsers = [];
                this.$vs.notify({
                    title: "Lista compartilhada!",
                    text: "Lista compartilhada com sucesso",
                    color: "success",
                    iconPack: "feather",
                    icon: "icon-alert-circle"
                });
            } catch (error) {
                console.log(error.message);
                this.$vs.loading.close();
                this.$vs.notify({
                    title: "Erro, não foi possível compartilhar lista de favoritos",
                    text: error.message,
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circle"
                });
            }
        },
        confirmDeleteShare(id){
            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: "Tem certeza que deseja remover o compartilhamento?",
                text: "O usuário não poderá visualizar a lista.",
                acceptText: "Deletar",
                cancelText: "Cancelar",
                accept: () => this.deleteHandlerShare(id)
            });
        },
        async deleteHandlerShare(id){

            this.$vs.loading();

            try {
                await this.removeUserFavoriteList({"user_id":id, "favorite_list_id":this.$route.params.id});
                this.$vs.loading.close();
                this.$vs.notify({
                    title: "Compartilhamento removido!",
                    text: "Compartilhamento removido com sucesso!",
                    color: "success",
                    iconPack: "feather",
                    icon: "icon-alert-circle"
                });
            } catch (error) {
                console.log(error.message);
                this.$vs.loading.close();
                this.$vs.notify({
                    title: "Não foi possível remover o compartilhamento.",
                    text: error.message,
                    color: "success",
                    iconPack: "feather",
                    icon: "icon-alert-circle"
                });
            }
        }
    }
}
</script>

<style lang="scss">
#data-list-list-view {
    .vs-con-table {
        .vs-table--header {
            display: flex;
            flex-wrap: wrap-reverse;
            margin-left: 1.5rem;
            margin-right: 1.5rem;
            > span {
                display: flex;
                flex-grow: 1;
            }

            .vs-table--search {
                padding-top: 0;

                .vs-table--search-input {
                    padding: 0.9rem 2.5rem;
                    font-size: 1rem;

                    & + i {
                        left: 1rem;
                    }

                    &:focus + i {
                        left: 1rem;
                    }
                }
            }
        }

        .vs-table {
            border-collapse: separate;
            border-spacing: 0 1.3rem;
            padding: 0 1rem;

            tr {
                box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
                td {
                    padding: 20px;
                    &:first-child {
                        border-top-left-radius: 0.5rem;
                        border-bottom-left-radius: 0.5rem;
                    }
                    &:last-child {
                        border-top-right-radius: 0.5rem;
                        border-bottom-right-radius: 0.5rem;
                    }
                }
                td.td-check {
                    padding: 20px !important;
                }
            }
        }

        .vs-table--thead {
            th {
                padding-top: 0;
                padding-bottom: 0;

                .vs-table-text {
                    text-transform: uppercase;
                    font-weight: 600;
                }
            }
            th.td-check {
                padding: 0 15px !important;
            }
            tr {
                background: none;
                box-shadow: none;
            }
        }

        .vs-table--pagination {
            justify-content: center;
        }


        // vs-button
        .vs-button{
            margin-left:20px;
        }
    }
}
</style>